<template>
    <b-row style="min-height: 681px">
        <b-col sm="12">
            <b-card>
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row>
                            <b-col sm="1"></b-col>
                            <b-col sm="10">
                                * 제외어는 인기검색어에서 해당 제외어를 제외 합니다.
                            </b-col>
                            <b-col sm="1"></b-col>
                        </b-row>
                        <b-row class="pt-sm-2">
                            <b-col sm="1"></b-col>
                            <b-col sm="5" style="font-weight: 600;">제외어</b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="1" style="text-align: center;">
                                <span class="card-title wise-card-title">제외어추가</span>
                            </b-col>
                            <b-col sm="4">
                                <b-form-input type="text" v-model="queryPrams.key" />
                            </b-col>
                            <b-col sm="1">
                                <b-button variant="outline-primary" v-on:click="fnAddExceptKeyword">추가</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <b-card>
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row class="pt-sm-4">
                            <b-col sm="2" style="text-align: center;"><span class="card-title wise-card-title">제외어 목록</span></b-col>
                            <b-col sm="2" style="text-align: center;">
                                <b-form-input
                                    id="filter-input"
                                    v-model="filterExcept"
                                    type="search"
                                    placeholder="제외어를 입력해주세요."></b-form-input>
                            </b-col>
                            <b-col sm="2" style="text-align: center;">
                                <b-form-group label-cols-sm="5" label="" class="mb-0">
                                <b-form-select
                                    v-model="rowPageExcept"
                                    :options="pageOptionsExcept"></b-form-select>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4" style="text-align: center;"><span class="card-title wise-card-title">원본 인기검색어</span></b-col>
                            <b-col sm="2" style="text-align: center;">
                                <b-form-group label-cols-sm="5" label="" class="mb-0">
                                <b-form-select
                                    v-model="rowPage"
                                    :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-sm-2">
                            <b-col sm="6">
                                <b-table outlined 
                                    :fields="fieldsExcept" 
                                    :filter="filterExcept"
                                    @filtered="onFiltered"
                                    :items="itemsExcept"
                                    :busy="itemsExcept == 0"
                                    :current-page="currentPageExcept"
                                    :per-page="rowPageExcept">
                                    <div slot="table-busy" class="text-center my-2">
                                        <strong>데이터가 없습니다.</strong>
                                    </div>
                                    <template slot="del" slot-scope="row">
                                        <b-button v-if="row.item.key !== ''"
                                            variant="outline-danger" size="sm"
                                            style="padding: 0rem 0.5rem;"
                                            v-on:click="fnDelKeyword(row.item)">삭제</b-button>
                                    </template>
                                </b-table>
                            </b-col>

                            <b-col sm="6">
                                <b-table outlined 
                                    :fields="fields" 
                                    :items="items"
                                    :busy="items == 0"
                                    :current-page="currentPage"
                                    :per-page="rowPage">
                                    <div slot="table-busy" class="text-center my-2">
                                        <strong>데이터가 없습니다.</strong>
                                    </div>
                                </b-table>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <!-- 페이징 -->
                                <b-row class="pb-sm-2">
                                    <b-col sm="1"></b-col>
                                    <b-col sm="10" class="my-1">
                                        <b-pagination
                                        v-model="currentPageExcept"
                                        :total-rows="totalRowsExcept"
                                        :per-page="rowPageExcept"
                                        :limit="limitPageExcept"
                                        align="center"
                                        ></b-pagination>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col sm="6">
                                <!-- 페이징 -->
                                <b-row class="pb-sm-2">
                                    <b-col sm="1"></b-col>
                                    <b-col sm="10" class="my-1">
                                        <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="rowPage"
                                        :limit="limitPage"
                                        align="center"
                                        ></b-pagination>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import swal from 'sweetalert2'

export default {
    name: "searchExceptManageList",
    data() {
        return {
            queryPrams: {
                key: "",
            },

            listLoading: false,
            totalRows: 0,
            currentPage: 1,
            limitPage: 10,
            rowPage: 10,
            pageOptions: [10, 30, 50, 100],
            fields: [
                { rank: { label: "순위", tdClass: 'searchArea' } },
                { key: { label: "제외어", tdClass: 'searchArea' } }
            ],
            items: [],

            listLoadingExcept: false,
            totalRowsExcept: 0,
            currentPageExcept: 1,
            limitPageExcept: 10,
            rowPageExcept: 10,
            pageOptionsExcept: [10, 30, 50, 100],
            fieldsExcept: [
                { key: { label: "인기검색어", tdClass: 'searchArea' } },
                { del: { label: "삭제", tdClass: 'searchArea' } },
            ],
            filterExcept: null,
            itemsExcept: [],
        }
    },
    mounted() {
        this.findExcepList();
        this.findNaturalList();
    },
    methods: {
        findNaturalList() {
            this.listLoading = true;
            this.$http1
                .get("/search/naturalPopularity")
                .then((result) => {
                    const { data } = result;
                    this.items = [];
                    this.items = data;
                    this.totalRows = data.length;
                    this.listLoading = false;
            });
        },
        findExcepList() {
            this.listLoadingExcept = true;
            this.$http1
                .get("/search/excepKeywordAdmin")
                .then((result) => {
                    const { data } = result;
                    this.itemsExcept = [];
                    this.itemsExcept = data;
                    this.totalRowsExcept = data.length;
                    this.listLoadingExcept = false;
            });
        },
        fnAddExceptKeyword() {
            const reg = /\s/g;
            this.queryPrams.key = this.queryPrams.key.replace(reg, "");

            if(this.queryPrams.key === ''){
                swal.fire({
                    type: 'warning',
                    title: '제외어를 입력하여주세요.',
                    showConfirmButton: false,
                    timer: 1500
                })
            }else{
                swal.fire({
                    text: "'" + this.queryPrams.key + "' 추가 하시겠습니까?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {
                        const param = JSON.stringify(this.queryPrams);
                        this.$http1
                        .post("/search/insertExceptPopularKeyword", param
                            , { headers: { "Content-Type": `application/json`} })
                        .then((result) => {
                            const { data } = result;
                            // console.log('===> ', result);
                            if(data === 'ok'){
                                swal.fire({
                                    type: 'success',
                                    title: '추가 완료 하였습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
        
                                this.findExcepList();
                                this.findNaturalList();
        
                                this.queryPrams.key = "";
                            }else if(data === 'dup'){
                                swal.fire({
                                    type: 'warning',
                                    title: '해당 제외어는 이미 등록되어 있습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                            }else{
                                swal.fire({
                                    type: 'error',
                                    title: '추가 중 오류가 발생하였습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                            }
                        });
                    }
                })
            }
        },
        fnDelKeyword(item) {
            swal.fire({
                    text: "'" + item.key + "' 삭제 하시겠습니까?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {
                        const param = JSON.stringify(item);
                        this.$http1
                            .post("/search/deleteExcepPopularKeyword", param
                                , { headers: { "Content-Type": `application/json`} })
                            .then((result) => {
                                const { data } = result;
                                console.log('===> ', result);
                                if(data === 'ok'){
                                    swal.fire({
                                        type: 'success',
                                        title: '삭제 완료 하였습니다.',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })

                                    this.findExcepList();
                                    this.findNaturalList();
                                }else{
                                    swal.fire({
                                        type: 'error',
                                        title: '삭제 중 오류가 발생하였습니다.',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                }
                        });
                    }
                  })            
        },
        onFiltered(filteredItems) {
            this.totalRowsExcept = filteredItems.length;
            this.currentPageExcept = 1;
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/views/site/search/component/tabs/searchExceptManage/SearchExceptManageList.vue